var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable class-methods-use-this */
import AuthClient from './AuthClient';
import { appEventMessageType, appPostMessageEventType } from './constants';
import { appLoggedIn, autobind } from './decorators';
import { decodeToken } from './keycloakDecodeToken';
const AUTH_TOKEN_CACHE_TIME_IN_MS = 5000;
// Stores auth and id token in sessions storage,
// So refreshing page does not lose state.
const AUTH_TOKEN_SESSION_KEY = 'authTokenCache';
const ID_TOKEN_SESSION_KEY = 'idTokenCache';
// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
function exhaustiveGuard(_value) {
    return null;
}
let AppAuthClient = (() => {
    var _a;
    let _classSuper = AuthClient;
    let _instanceExtraInitializers = [];
    let _init_decorators;
    let _login_decorators;
    let _stepUp_decorators;
    let _getToken_decorators;
    let _updateToken_decorators;
    let _get_needSetupUp_decorators;
    let _get_idTokenParsed_decorators;
    let _get_sub_decorators;
    let _get_nin_decorators;
    let _get_canStepUp_decorators;
    return _a = class AppAuthClient extends _classSuper {
            constructor(options) {
                var _b, _c, _d, _e;
                super(options);
                this.accessToken = __runInitializers(this, _instanceExtraInitializers);
                this.shouldRefetchToken = false;
                this.accessToken = (_b = sessionStorage.getItem(AUTH_TOKEN_SESSION_KEY)) !== null && _b !== void 0 ? _b : (_c = window.nativeToWebviewData.auth) === null || _c === void 0 ? void 0 : _c.accessToken;
                this.idToken = (_d = sessionStorage.getItem(ID_TOKEN_SESSION_KEY)) !== null && _d !== void 0 ? _d : (_e = window.nativeToWebviewData.auth) === null || _e === void 0 ? void 0 : _e.idToken;
                this.addAppEventListener();
            }
            addAppEventListener() {
                const appEventListener = (event) => {
                    const eventData = JSON.parse(event.data);
                    if (!(eventData === null || eventData === void 0 ? void 0 : eventData.type)) {
                        return;
                    }
                    switch (eventData === null || eventData === void 0 ? void 0 : eventData.type) {
                        case appEventMessageType.newToken:
                            sessionStorage.setItem(AUTH_TOKEN_SESSION_KEY, eventData.accessToken);
                            sessionStorage.setItem(ID_TOKEN_SESSION_KEY, eventData.idToken);
                            this.accessToken = eventData.accessToken;
                            this.idToken = eventData.idToken;
                            break;
                        case appEventMessageType.loggedOut:
                            window.nativeToWebviewData = {};
                            sessionStorage.removeItem(AUTH_TOKEN_SESSION_KEY);
                            sessionStorage.removeItem(ID_TOKEN_SESSION_KEY);
                            this.idToken = undefined;
                            this.accessToken = undefined;
                            break;
                        case appEventMessageType.navigateTo:
                            window.location.assign(eventData.url);
                            break;
                        case appEventMessageType.authFailed:
                            // We do not have anywhere to go on auth error,
                            // so just reload current page which might be awaiting a promise.
                            window.location.reload();
                            break;
                        default:
                            exhaustiveGuard(eventData);
                    }
                };
                // Android uses document messages
                document.addEventListener('message', appEventListener);
                // iOS uses window messages
                window.addEventListener('message', appEventListener);
            }
            /**
             * The actual init should be handled by the app, this will always expect that it is
             */
            init() {
                return __awaiter(this, void 0, void 0, function* () {
                    return Promise.resolve(true);
                });
            }
            /**
             * The actual loginUrl should be created in the app, createLoginUrl is not
             * supported when auth is in app-mode
             */
            createLoginUrl() {
                return __awaiter(this, void 0, void 0, function* () {
                    throw new Error('createLoginUrl is not supported when auth is in app-mode');
                });
            }
            login() {
                return __awaiter(this, arguments, void 0, function* (loginOptions = this.options.login) {
                    const triggerLogin = loginOptions.prompt === 'login';
                    if (this.authenticated && !triggerLogin) {
                        // Already logged in? Do nothing (matches browser client)
                        return Promise.resolve();
                    }
                    return new Promise(() => {
                        var _b, _c;
                        window.ReactNativeWebView.postMessage(JSON.stringify({
                            type: appPostMessageEventType.login,
                            // Use user provided redirect url or trigger navigation(refresh) on current page.
                            // Matches Browser auth client behavior.
                            redirectUri: (_b = loginOptions.redirectUri) !== null && _b !== void 0 ? _b : window.location.origin,
                            onCancelAction: (_c = loginOptions.onCancelAction) !== null && _c !== void 0 ? _c : 'nothing',
                        }));
                        // No resolve or reject, as result is always a redirect.
                    });
                });
            }
            stepUp() {
                return __awaiter(this, arguments, void 0, function* (loginOptions = this.options.login) {
                    return new Promise(() => {
                        var _b, _c;
                        window.ReactNativeWebView.postMessage(JSON.stringify({
                            type: appPostMessageEventType.stepUp,
                            // Use user provided redirect url or trigger navigation(refresh) on current page.
                            // Matches Browser auth client behavior.
                            redirectUri: (_b = loginOptions.redirectUri) !== null && _b !== void 0 ? _b : window.location.origin,
                            onCancelAction: (_c = loginOptions.onCancelAction) !== null && _c !== void 0 ? _c : 'nothing',
                        }));
                        // No resolve or reject, as result is always a redirect.
                    });
                });
            }
            logout() {
                return __awaiter(this, arguments, void 0, function* (logoutOptions = this.options.logout) {
                    return new Promise(() => {
                        var _b;
                        window.ReactNativeWebView.postMessage(JSON.stringify({
                            type: appPostMessageEventType.logout,
                            // Use user provided redirect url or trigger navigation(refresh) on current page.
                            // Matches Browser auth client behavior.
                            redirectUri: (_b = logoutOptions.redirectUri) !== null && _b !== void 0 ? _b : window.location.origin,
                        }));
                        // No resolve or reject, as result is always a redirect.
                    });
                });
            }
            /**
             * Returning the accessToken provided by the app. The token is cached
             * for 5 seconds to prevent excessive calls to the implementations in the Application.
             * Waits for a postMessage from the app before updating the token
             */
            getToken() {
                return __awaiter(this, void 0, void 0, function* () {
                    if (!this.authenticated) {
                        return Promise.resolve('');
                    }
                    const cacheEvict = AUTH_TOKEN_CACHE_TIME_IN_MS;
                    return new Promise((resolve) => {
                        if (!this.accessTokenTimeoutId) {
                            this.accessTokenTimeoutId = setTimeout(() => {
                                clearTimeout(this.accessTokenTimeoutId);
                                this.accessTokenTimeoutId = undefined;
                                this.shouldRefetchToken = true;
                            }, cacheEvict);
                        }
                        if (this.shouldRefetchToken || !this.accessToken) {
                            this.shouldRefetchToken = false;
                            const tokenUpdatedCallback = (event) => {
                                const eventData = JSON.parse(event.data);
                                if ((eventData === null || eventData === void 0 ? void 0 : eventData.type) === appEventMessageType.newToken) {
                                    document.removeEventListener('message', tokenUpdatedCallback);
                                    window.removeEventListener('message', tokenUpdatedCallback);
                                    // Token is already stored by listener above.
                                    resolve(eventData.accessToken);
                                }
                            };
                            document.addEventListener('message', tokenUpdatedCallback);
                            window.addEventListener('message', tokenUpdatedCallback);
                            window.ReactNativeWebView.postMessage(JSON.stringify({
                                type: appPostMessageEventType.updateToken,
                            }));
                        }
                        else {
                            resolve(this.accessToken);
                        }
                    });
                });
            }
            /**
             * App handles refreshing and have offline access scope,
             * so it will never expire within web session.
             */
            isTokenExpired() {
                return false;
            }
            /**
             * App handles refreshing and have offline access scope,
             * so it will never expire within web session.
             */
            isRefreshTokenExpired() {
                return false;
            }
            /**
             * The actual updateToken should be handled by the app, this implementation will only send
             * a request to update the token. The response from this function returns whether the request
             * has been sent successfully or not.
             */
            updateToken() {
                return __awaiter(this, void 0, void 0, function* () {
                    window.ReactNativeWebView.postMessage(JSON.stringify({
                        type: appPostMessageEventType.updateToken,
                    }));
                    return Promise.resolve(true);
                });
            }
            /**
             * When in a web view, auth will always be already initialized.
             */
            get isInitialized() {
                return true;
            }
            get needSetupUp() {
                return super.needStepUp;
            }
            get authenticated() {
                return !!this.accessToken;
            }
            get authenticatedOnBehalfOf() {
                throw new Error('authenticatedOnBehalfOf is not supported when auth is in app-mode');
            }
            get idTokenParsed() {
                return decodeToken(this.idToken);
            }
            get advisor() {
                throw new Error('advisor is not supported when auth is in app-mode');
            }
            get sub() {
                return super.sub;
            }
            get nin() {
                return super.nin;
            }
            get canStepUp() {
                return super.canStepUp;
            }
        },
        (() => {
            var _b;
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
            _init_decorators = [autobind];
            _login_decorators = [autobind];
            _stepUp_decorators = [appLoggedIn, autobind];
            _getToken_decorators = [autobind];
            _updateToken_decorators = [appLoggedIn];
            _get_needSetupUp_decorators = [appLoggedIn];
            _get_idTokenParsed_decorators = [appLoggedIn];
            _get_sub_decorators = [appLoggedIn];
            _get_nin_decorators = [appLoggedIn];
            _get_canStepUp_decorators = [appLoggedIn];
            __esDecorate(_a, null, _init_decorators, { kind: "method", name: "init", static: false, private: false, access: { has: obj => "init" in obj, get: obj => obj.init }, metadata: _metadata }, null, _instanceExtraInitializers);
            __esDecorate(_a, null, _login_decorators, { kind: "method", name: "login", static: false, private: false, access: { has: obj => "login" in obj, get: obj => obj.login }, metadata: _metadata }, null, _instanceExtraInitializers);
            __esDecorate(_a, null, _stepUp_decorators, { kind: "method", name: "stepUp", static: false, private: false, access: { has: obj => "stepUp" in obj, get: obj => obj.stepUp }, metadata: _metadata }, null, _instanceExtraInitializers);
            __esDecorate(_a, null, _getToken_decorators, { kind: "method", name: "getToken", static: false, private: false, access: { has: obj => "getToken" in obj, get: obj => obj.getToken }, metadata: _metadata }, null, _instanceExtraInitializers);
            __esDecorate(_a, null, _updateToken_decorators, { kind: "method", name: "updateToken", static: false, private: false, access: { has: obj => "updateToken" in obj, get: obj => obj.updateToken }, metadata: _metadata }, null, _instanceExtraInitializers);
            __esDecorate(_a, null, _get_needSetupUp_decorators, { kind: "getter", name: "needSetupUp", static: false, private: false, access: { has: obj => "needSetupUp" in obj, get: obj => obj.needSetupUp }, metadata: _metadata }, null, _instanceExtraInitializers);
            __esDecorate(_a, null, _get_idTokenParsed_decorators, { kind: "getter", name: "idTokenParsed", static: false, private: false, access: { has: obj => "idTokenParsed" in obj, get: obj => obj.idTokenParsed }, metadata: _metadata }, null, _instanceExtraInitializers);
            __esDecorate(_a, null, _get_sub_decorators, { kind: "getter", name: "sub", static: false, private: false, access: { has: obj => "sub" in obj, get: obj => obj.sub }, metadata: _metadata }, null, _instanceExtraInitializers);
            __esDecorate(_a, null, _get_nin_decorators, { kind: "getter", name: "nin", static: false, private: false, access: { has: obj => "nin" in obj, get: obj => obj.nin }, metadata: _metadata }, null, _instanceExtraInitializers);
            __esDecorate(_a, null, _get_canStepUp_decorators, { kind: "getter", name: "canStepUp", static: false, private: false, access: { has: obj => "canStepUp" in obj, get: obj => obj.canStepUp }, metadata: _metadata }, null, _instanceExtraInitializers);
            if (_metadata) Object.defineProperty(_a, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
        })(),
        _a;
})();
export default AppAuthClient;
